import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type {
  IEvaluateInvestorAnalysisRequest,
  IFinishInvestorAnalysisRequest,
} from '~/@api/generated-api-types-user/Api'
import { useUser } from '~/@biz_account/useUser/useUser'
import { sleep } from '~/@lib/utils/type.utils'
import { getInvestorAnalysisVersion } from './analysis-versions/investorAnalysisVersions'

function useInvestorAnalysis() {
  const client = useApiClientUser()
  const { reloadUser } = useUser()

  return {
    // priebežné vyhodnotenie na rozcestiach dotazníka, nič neukladá
    evaluateInvestorAnalysis: async (
      args: Omit<IEvaluateInvestorAnalysisRequest, 'version'>
    ) => {
      const resp =
        await client.user.onboardingControllerEvaluateInvestorAnalysis(
          { ...args, version: getInvestorAnalysisVersion().version },
          { secure: true }
        )
      return resp.data
    },
    finishInvestorAnalysis: async (
      args: Omit<IFinishInvestorAnalysisRequest, 'version'>
    ) => {
      const resp = await client.user.onboardingControllerFinishInvestorAnalysis(
        { ...args, version: getInvestorAnalysisVersion().version },
        {
          secure: true,
        }
      )
      await sleep(1000)
      await reloadUser()
      return resp
    },
    resetInvestorAnalysis: async () => {
      const resp = await client.user.onboardingControllerResetInvestorAnalysis({
        secure: true,
      })
      await reloadUser()
      return resp
    },
  }
}

export { useInvestorAnalysis }
